/*
  Fall Sale tier sync (loaded by snippets/cart-drawer.liquid).
  Only acts when the cart has a FALLSALE2/3/4 code. After any cart change it counts the harnesses
  (product personalized-anti-pull-harness) and swaps the code to the matching tier:
  2 → FALLSALE2, 3 → FALLSALE3, 4+ → FALLSALE4, 1 or 0 → code removed.
  Carts without a FALLSALE code are never touched.
*/
(function () {
  if (window.__fsTierSync) return;
  window.__fsTierSync = true;

  var HANDLE = 'personalized-anti-pull-harness';
  var TIER = { 2: 'FALLSALE2', 3: 'FALLSALE3', 4: 'FALLSALE4' };
  var running = false;

  function sync() {
    if (running) return;
    running = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
        var current = codes.filter(function (c) { return /^FALLSALE[234]$/.test(c); });
        if (!current.length) return;
        var n = cart.items.reduce(function (s, i) { return s + (i.handle === HANDLE ? i.quantity : 0); }, 0);
        var want = n >= 2 ? TIER[Math.min(n, 4)] : '';
        if (current.length === 1 && current[0] === want) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: want })
        }).then(function () {
          if (location.pathname === '/cart') { location.reload(); return; }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fs-tier-sync' });
        });
      })
      .catch(function () {})
      .finally(function () { running = false; });
  }

  function init() {
    // PUB_SUB_EVENTS is a top-level const in constants.js (not a window property).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'fs-tier-sync') return;
        setTimeout(sync, 300);
      });
    }
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
